import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../../components/tables/ReportsTable';

const TdsReports = () => {
  // Sample data generator
  const generateSampleData = (count = 50) => {
    const quarters = ['Q1 (Apr-Jun)', 'Q2 (Jul-Sep)', 'Q3 (Oct-Dec)', 'Q4 (Jan-Mar)'];
    const years = ['2023-24', '2024-25'];
    
    return Array.from({ length: count }, (_, i) => ({
      tdsId: `TDS${String(i + 1).padStart(6, '0')}`,
      date: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1)
        .toISOString().split('T')[0],
      userId: `USER${String(Math.floor(Math.random() * 500) + 1).padStart(4, '0')}`,
      userName: `User ${Math.floor(Math.random() * 500) + 1}`,
      panCard: `${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${Math.floor(Math.random() * 10000).toString().padStart(4, '0')}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}`,
      commission: (Math.random() * 10000 + 1000).toFixed(2),
      tdsRate: '5%',
      tdsAmount: (Math.random() * 500 + 50).toFixed(2),
      netAmount: (Math.random() * 9500 + 950).toFixed(2),
      quarter: quarters[Math.floor(Math.random() * quarters.length)],
      financialYear: years[Math.floor(Math.random() * years.length)],
      challanNo: `CHL${Math.floor(Math.random() * 10000000)}`,
      status: Math.random() > 0.2 ? 'Deducted' : 'Pending'
    }));
  };

  const [data] = useState(generateSampleData(60));

  // Column definitions
  const columns = [
    { key: 'tdsId', label: 'TDS ID' },
    { key: 'date', label: 'Date' },
    { key: 'userId', label: 'User ID' },
    { key: 'userName', label: 'User Name' },
    { key: 'panCard', label: 'PAN Card' },
    { key: 'commission', label: 'Commission' },
    { key: 'tdsRate', label: 'TDS Rate' },
    { key: 'tdsAmount', label: 'TDS Amount' },
    { key: 'netAmount', label: 'Net Amount' },
    { key: 'quarter', label: 'Quarter' },
    { key: 'financialYear', label: 'Financial Year' },
    { key: 'challanNo', label: 'Challan No' },
    { key: 'status', label: 'Status' }
  ];

  return (
    <Container fluid className="">
      <ReportsTable
        data={data}
        reportType="TDS_Reports"
        columns={columns}
        title="TDS Reports"
      />
    </Container>
  );
};

export default TdsReports;

